import api from './client'

export interface Category {
  id: string
  companyId: string
  name: string | null
  nameIt: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

const base = (cid: string) => `/companies/${cid}/categories`

export const categoriesApi = {
  list: (cid: string, opts?: { includeInactive?: boolean }) =>
    api.get<Category[]>(base(cid), { params: { includeInactive: opts?.includeInactive ? 'true' : undefined } }).then(r => r.data),
  create: (cid: string, dto: { name?: string; nameIt?: string }) =>
    api.post<Category>(base(cid), dto).then(r => r.data),
  update: (cid: string, id: string, dto: { name?: string; nameIt?: string; isActive?: boolean }) =>
    api.patch<Category>(`${base(cid)}/${id}`, dto).then(r => r.data),
  remove: (cid: string, id: string) => api.delete(`${base(cid)}/${id}`),
}
